import {
  chartIntervals,
  chartSourceInfo,
  intervalToDays,
  intervalToFormatType,
} from '@consts/chart';
import { useIntersectionObserver } from '@hooks/useIntersectionObserver';
import { useAssetInfo } from '@queries/useAssetInfo';
import { ChartProps } from '@student-coin/coinpaper-components/dist/components/Chart/Chart.types';
import dynamic from 'next/dist/shared/lib/dynamic';
import { FC, useCallback, useRef, useState } from 'react';
import { Container } from './AssetChart.styles';
import { AssetChartProps, XAxisFormat } from './AssetChart.types';

const Chart = dynamic(
  () => import('@student-coin/coinpaper-components').then((mod) => mod.Chart as FC<ChartProps>),
  {
    ssr: false,
  },
);

export const AssetChart: FC<AssetChartProps> = ({ assetTicker }) => {
  const [selectedInterval, setSelectedInterval] = useState(1);
  const [xAxisFormat, setXAxisFormat] = useState<XAxisFormat>('hour');
  const containerRef = useRef();
  const intersectionEntry = useIntersectionObserver(containerRef, {
    threshold: 0,
    freezeOnceVisible: true,
  });

  const inView = !!intersectionEntry?.isIntersecting;
  const { data, isLoading, isSuccess } = useAssetInfo(assetTicker, selectedInterval, inView);
  const onChartTabChange = useCallback((tab) => {
    setSelectedInterval(intervalToDays[tab]);
    setXAxisFormat(intervalToFormatType[tab]);
  }, []);

  return (
    <Container ref={containerRef}>
      {inView && isSuccess && (
        <Chart
          info={null}
          name={data?.name}
          shortname={assetTicker}
          logoSrc={data?.image}
          price={data?.price.current}
          intervals={chartIntervals}
          data={data?.pricesData}
          captionDate={data?.lastUpdated}
          captionLink={chartSourceInfo}
          xAxisFormat={xAxisFormat}
          onTabChange={onChartTabChange}
          loading={isLoading}
        />
      )}
    </Container>
  );
};
